/*
  «Выбрать показанные» над списком на узком экране - строка 295 реестра, 28.10.2026.

  Флажок «выбрать все» лежит в шапке таблицы, а на телефоне таблица разворачивается в
  карточки и шапка уходит с глаз (`styles.adaptive.css`): остаётся «Выбрать весь отбор»,
  а отметить страницу можно только по строке. Кнопка дублирует шапку и видна только на
  узком экране (класс `pick-shown`); на широком её нет, чтобы не было двух способов сделать
  одно и то же рядом.

  Берёт ровно показанную страницу, как и флажок в шапке (решение владельца 09.09.2026).
*/

export default function PickShown({ count, picked, onToggle }) {
  if (!count) return null
  const all = picked === count
  return (
    <div className="pick-shown">
      <button type="button" className="button button--quiet" onClick={() => onToggle(!all)}>
        {all ? 'Снять показанные' : 'Выбрать показанные'}
      </button>
    </div>
  )
}
